import { configureStore } from '@reduxjs/toolkit';
import counter from './reducers/counter.slice';
import todo from './reducers/todo.reducer';
import createSagaMiddleware from 'redux-saga';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import rootSaga from './sagas';
import auth from './reducers/auth.slice';
import system from './reducers/system.slice';
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
	reducer: {
		counter,
		todo,
		auth,
		system,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
